import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_20: FaireProductEntity = {
  token: "sweet-wink-20",
  type: "product",
  name: "Mardi Gras Tulle Bow Clip - Kids Hair Bows - Mardi Gras",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/aae437b90ddf78c9863ec1cc4e3570014d22ceba8a5e32e670cba0d2ed84fe64.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1113,1113,x44,y49,safe&width=720",
  priceDollars: 8,
  msrpDollars: 16,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
